define.alias("shared/components/shared/social/refresh-profile/threads", "calendar/components/shared/social/refresh-profile/threads");